// Random per-browser-profile ID, not a hardware serial — tells devices
// apart for the Access & Devices approval flow (see backend's
// services/accessControl.js). Persisted in localStorage so it survives
// reloads but is private to this browser profile.
const KEY = 'primeclean_device_id';

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = `dev_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null; // private window / blocked storage — server treats this as DEVICE_UNKNOWN when device enforcement is on
  }
}
